import { SportsLiveListType } from "@/type/list"
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import defaultThumnail from "@/public/image/etc/liveCommon.png"

import { useContext, useEffect, useState } from "react"
import { LiveStreamContext } from "../_config"
import live from "@/public/image/etc/live.png"
import loadingJson from "@/public/media/load_data.json"
import Lottie from "react-lottie-player"
import MultiSelect from "./multi_select"
import RefreshTimer from "./refresh_timer"
import { useTranslations } from "next-intl"

export default function LiveSportsList({ list }: { list: SportsLiveListType[] }) {
    const [mount, setMount] = useState<boolean>(false)
    const [liveList, setLiveList] = useState<SportsLiveListType[]>()
    const [nonLiveList, setNonLiveList] = useState<SportsLiveListType[]>()
    const [loading, setLoading] = useState<boolean>(true)
    
    const p = useTranslations('PageTitle')
    const a = useTranslations('Sentence')

    useEffect(() => {
        const defaultList = list
        setLiveList(defaultList.filter((el) => el.states == 'ING' && el.video))
        setNonLiveList(defaultList.filter((el) => el.states != 'ING'))

        setMount(true)
    }, [list])

    useEffect(() => {
        // if(!mount) return;
        setLoading(false)
    }, [])

    return (
        <div className="live-sports-list">
            <div className="page-title">{p('중계 라이브 목록')}
                <RefreshTimer setLoading={setLoading} />
            </div>
            {
                !loading
                    ? !liveList && !nonLiveList
                        ? <ul>
                            {
                                !list || !list.length
                                && <li className="empty">{a('InvalidLive')}</li>
                            }
                        </ul>
                        : <>
                            <ul>
                                {
                                    liveList && liveList.length
                                        ? liveList.map((li, index) => (
                                            <LiveSportsListItem key={index} li={li} />
                                        ))
                                        : <></>
                                }
                            </ul>
                            <ul>
                                {
                                    nonLiveList
                                        &&
                                        nonLiveList.length
                                        ? nonLiveList.map((li, index) => (
                                            <LiveSportsListItem key={index} li={li} />
                                        ))
                                        : <></>
                                }
                            </ul>
                        </>
                    // : <Lottie loop animationData={loadingJson} play style={{ maxWidth: `400px`, margin: "0 auto" }} />
                    : <ul>
                        {
                            [...Array(10)].map((_, index) => ( <LiveSportsListItemPlaceholder key={index} /> ))
                        }
                    </ul>

            }
        </div>
    )
}

function LiveSportsListItem({ li }: { li: SportsLiveListType }) {
    const { stream_1, stream_2, stream_3, stream_4, set_recentUrl, AddViewUrl } = useContext(LiveStreamContext)
    const [selected, setSelected] = useState<boolean>(false)
    const scheduleDateTime = li.date

    const t = useTranslations('Text')
    const a = useTranslations('Sentence')

    useEffect(() => {
        const streams = [stream_1, stream_2, stream_3, stream_4]
        if(streams.includes(li)){
            setSelected(true)
        }else{
            setSelected(false)
        }
    }, [stream_1, stream_2, stream_3, stream_4])

    return (
        <li className={selected ? "selected" : ""}>
            <div className="onclick-cover"  onClick={e => li.states == 'ING' && set_recentUrl(li)}></div>
            <div className={`tumbnail type-${li.states}`}>
                
                {
                    li.thumbnail
                        ? <img src={li.thumbnail} 
                               alt={li.thumbnail} 
                               onError={(e) => {
                                           e.currentTarget.onerror = null;
                                           e.currentTarget.src = defaultThumnail.src;
                                }} />
                        : <div className="empty-thumnail">
                            {
                                li.leagueName == "HD"
                                    ? li.home_name
                                    : li.leagueName
                            }
                        </div>
                }
            </div>
            {
                li.leagueName != "HD"
                    ? <SportsInfo li={li} />
                    : <HDInfo li={li} />
            }
            <div className="live">
                <button>
                    {
                        li.states == 'ING' && li.video
                            ? <>
                                {/* <img src={live.src} alt="live" onClick={e => set_recentUrl(li)} /> */}
                                <MultiSelect listItem={li} />
                            </>
                            : <span className="ready-live">{t('대기중')}</span>
                    }
                    {/* <FontAwesomeIcon icon={faMagnifyingGlass} /> */}
                </button>
            </div>
        </li>
    )
}
function LiveSportsListItemPlaceholder() {
    return (
        <li className="placeholder">
            <div className={`tumbnail`}>
                <div className="empty-thumnail"></div>
            </div>
            <div className="info">
            <header>
                <span className="league">
                    <i className={`--i sports`}></i>
                    <p className="empty-space"></p>
                </span>
                <span className="date">
                    <p className="empty-space"></p>
                </span>
            </header>
            <div className="teams">
                <div>
                    <span className="ha home"></span>
                    <p className="empty-space"></p>
                </div>
                <div>
                    <span className="ha away"></span>
                    <p className="empty-space"></p>
                </div>
            </div>
        </div>
            <div className="live">
                <button>
                    <div className="multi-select">
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>
        </li>
    )
}


function SportsInfo({ li }: { li: SportsLiveListType }) {
    return (
        <div className="info">
            <header>
                <span className="league">
                    <i className={`--i sports ${li.sports}`}></i>
                    <p>{li.leagueName}</p>
                </span>
                <span className="date">{li.date}</span>
            </header>
            <div className="teams">
                <div>
                    <span className="ha home"></span>
                    <p>{li.home_name}</p>
                </div>
                <div>
                    <span className="ha away"></span>
                    <p>{li.away_name}</p>
                </div>
            </div>
        </div>
    )
}
function HDInfo({ li }: { li: SportsLiveListType }) {
    return (
        <div className="info">
            <header>
                <span className="league">HD LIVE</span>
            </header>
            <div className="hd-name">
                <p>{li.home_name}</p>
            </div>
        </div>
    )
}